import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-erro-page',
  templateUrl: './erro-page.component.html',
  styleUrls: ['./erro-page.component.css']
})
export class ErroPageComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
